type MakeValidNumberOptions = {
  numberType?: 'integer' | 'float';
  min?: number;
  max?: number;
};

const makeValidNumber = (str: string | undefined | null, options: MakeValidNumberOptions = {}): number | null => {
  const { numberType = 'float', min, max } = options;

  if (str === undefined || str === null || str === '') {
    return null;
  }

  let asNumber = +str;
  if (Number.isNaN(asNumber)) {
    return null;
  }

  if (numberType === 'integer') {
    asNumber = Math.trunc(asNumber);
  }

  // Enforce min/max constraints by clamping
  if (min !== undefined && asNumber < min) {
    return min;
  }
  if (max !== undefined && asNumber > max) {
    return max;
  }

  return asNumber;
};

export default makeValidNumber;
